/* eslint-disable no-unused-vars */
import * as S from './Message.styled';
import { SuccessIcon, DefaultIcon, closeIcon } from 'assets/icons';
import { IconButton } from 'components';
import PropTypes from 'prop-types';

const messageType = {
  information: 'information',
  warning: 'warning',
  error: 'error',
  success: 'success',
  with_close_btn: 'with_close_btn',
};

export const Message = ({ children, type, isOpen, onCloseBtn, backgroundColor }) => {
  if (!isOpen) return null;
  return (
    <S.Container type={type} style={{ backgroundColor: backgroundColor }}>
      <S.IconWrap>{type === messageType.success ? <SuccessIcon /> : <DefaultIcon />}</S.IconWrap>
      <S.Paragraph>{children}</S.Paragraph>
      {type === messageType.with_close_btn && (
        <S.BtnWrap>
          <IconButton.SmallSize
            icon={closeIcon}
            type={IconButton.btnTypes.tertiary}
            onClick={onCloseBtn}
          />
        </S.BtnWrap>
      )}
    </S.Container>
  );
};

Message.messageType = { ...messageType };

Message.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  type: PropTypes.oneOf(Object.values(messageType)).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCloseBtn: PropTypes.func,
};
